import { create, type Suite } from "vest";
import { type CB } from "vest-utils";
import { availableFields } from "@/forms/available-fields";
import { createTextFieldValidationSuite } from "@/forms/validation/strategy/text-field";
import { createEmailFieldValidationSuite } from "@/forms/validation/strategy/email-field";
import { createPasswordFieldValidationSuite } from "@/forms/validation/strategy/password-field";
import { createNumberFieldValidationSuite } from "@/forms/validation/strategy/number-field";
import { createMultiselectFieldValidationSuite } from "@/forms/validation/strategy/multiselect-field";
import { createCheckboxFieldValidationSuite } from "@/forms/validation/strategy/checkbox-field";
import { createTextareaFieldValidationSuite } from "@/forms/validation/strategy/textarea-field";
import { createImageFieldValidationSuite } from "@/forms/validation/strategy/image-field";
import { createSelectFieldValidationSuite } from "@/forms/validation/strategy/select-field";
import { createFileFieldValidationSuite } from "@/forms/validation/strategy/file-field";
import { createRadioFieldValidationSuite } from "@/forms/validation/strategy/radio-field";
import { createHiddenFieldValidationSuite } from "@/forms/validation/strategy/hidden-field";
import { createPhoneFieldValidationSuite } from "@/forms/validation/strategy/phone-field";
import { createDateRangeFieldValidationSuite } from "@/forms/validation/strategy/date-range-field";
import { createRatingFieldValidationSuite } from "@/forms/validation/strategy/rating-field";

export function fromFormDefinitionToValidationSchema(
  fields: FormDefinitionType,
): Suite<string, string, CB> {
  const map: Record<FieldType, FormDefinitionValidator> = {
    [availableFields.text]: createTextFieldValidationSuite,
    [availableFields.phone]: createPhoneFieldValidationSuite,
    [availableFields.email]: createEmailFieldValidationSuite,
    [availableFields.password]: createPasswordFieldValidationSuite,
    [availableFields.number]: createNumberFieldValidationSuite,
    [availableFields.multiselect]: createMultiselectFieldValidationSuite,
    [availableFields.checkbox]: createCheckboxFieldValidationSuite,
    [availableFields.textarea]: createTextareaFieldValidationSuite,
    [availableFields.image]: createImageFieldValidationSuite,
    [availableFields.select]: createSelectFieldValidationSuite,
    [availableFields.date]: createTextFieldValidationSuite,
    [availableFields.dateRange]: createDateRangeFieldValidationSuite,
    [availableFields.file]: createFileFieldValidationSuite,
    [availableFields.radio]: createRadioFieldValidationSuite,
    [availableFields.hidden]: createHiddenFieldValidationSuite,
    [availableFields.rating]: createRatingFieldValidationSuite,
  };

  return create((data) => {
    Object.keys(fields).forEach((key) => {
      const field = fields[key];
      if (field.disabled) return;

      const mapper = map[field.type];
      mapper(field, data);
    });
  });
}
